import styled, { css } from "styled-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import MetricsCompareBars from "app/components/React/MetricsCompareBars/MetricsCompareBars";

// Table
export const MonetizationNetworksTableContainer = styled.div`
    width: 100%;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
    & .css-sticky-header {
        z-index: 1051;
    }
`;
MonetizationNetworksTableContainer.displayName = "MonetizationNetworksTableContainer";

interface IDisable {
    isDisabled?: boolean;
}

const StyledEnrichButton = styled(IconButton)<IDisable>`
    background: ${colorsPalettes.carbon[0]};
    padding: 0 8px;
    border-radius: 4px;
    border: 1px solid ${colorsPalettes.carbon[50]};

    > .SWReactIcons > svg > path {
        fill: ${(props) => colorsPalettes.carbon[props.isDisabled ? 100 : 300]};
    }

    ${(props) =>
        !props.isDisabled &&
        css`
            &:hover {
                border: 1px solid ${colorsPalettes.midnight[100]} !important;
                color: ${colorsPalettes.carbon[0]};
            }
        `}
`;
StyledEnrichButton.displayName = "StyledEnrichButton";

/* Top Bar */
export const TopHeadlineContainer = styled.div`
    padding: 20px;
    ${mixins.setFont({ $size: 20, $color: colorsPalettes.carbon[500], $weight: 500 })};
`;
TopHeadlineContainer.displayName = "TopHeadlineContainer";

export const Separator = styled.hr`
    border-top-color: ${colorsPalettes.carbon[50]};
    margin: 0;
`;
Separator.displayName = "Separator";

export const MetricsCompareBarsContainer = styled.div`
    padding: 24px 24px 26px 24px;
`;
MetricsCompareBarsContainer.displayName = "MetricsCompareBarsContainer";

export const MetricsCompareBarsStyled = styled(MetricsCompareBars)<{
    isFetching: boolean;
    items: any;
}>`
    ${css`
        flex-grow: 1;
    `}
`;
MetricsCompareBarsStyled.displayName = "MetricsCompareBarsStyled";

export const MetricsCompareBarsTitle = styled.div`
    ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon[400], $weight: 500 })};
    margin-bottom: 10px;
`;
MetricsCompareBarsTitle.displayName = "MetricsCompareBarsTitle";

export const SearchContainer = styled(CenteredFlexRow)`
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    padding: 8px 16px 8px 0;
    height: 40px;
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0px;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;
SearchContainer.displayName = "SearchContainer";

export const SectionContainer = styled(FlexRow)`
    justify-content: space-between;
    ${SearchContainer} {
        width: 100%;
        padding: 8px 0px 8px 0px;
        border-top: none;
    }
`;
SectionContainer.displayName = "SectionContainer";
